(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["huiliu-b2b"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hb [data-sku]').forEach(button=>button.addEventListener('click',()=>{const sku=document.getElementById('hb-sku');if(sku){sku.value=button.dataset.sku;document.getElementById('hb-intent').value='Trade quotation';document.getElementById('enquiry').scrollIntoView();sku.focus({preventScroll:true});}}));
document.querySelectorAll('.hb [data-intent]').forEach(link=>link.addEventListener('click',()=>{const field=document.getElementById('hb-intent');if(field)field.value=link.dataset.intent;}));
const method=document.getElementById('hb-method');if(method)method.addEventListener('change',()=>{document.getElementById('hb-contact').required=method.value!=='Email';});

  } catch(e) { console.error(e); }
})();
})();
